import * as React from 'react';

export const ContentRow: React.FC<React.PropsWithChildren> = ({ children }) => {
	return <div className="content__row">{children}</div>;
};
